/** Generated from validated recipes/route-props.json. */
import type { Recipe } from './contracts';
export const ROUTE_PROP_RECIPES = [
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.coastal_fallen_log.v1',
    'assetId': 'prop.route.coastal_fallen_log',
    'generatorId': 'route.fallen_log.v1',
    'template': 'coastal_fallen_log',
    'seed': 318,
    'paletteId': 'coastal_salt',
    'detail': 'standard',
    'params': {
      'width': 250,
      'height': 80,
      'profile': 'whole',
      'mossCover': 0.52,
      'saltWear': 0.28
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.coastal_split_log.v1',
    'assetId': 'prop.route.coastal_split_log',
    'generatorId': 'route.fallen_log.v1',
    'template': 'coastal_split_log',
    'seed': 527,
    'paletteId': 'coastal_salt',
    'detail': 'standard',
    'params': {
      'width': 180,
      'height': 55,
      'profile': 'split',
      'mossCover': 0.2,
      'saltWear': 0.4
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.moor_fallen_log.v1',
    'assetId': 'prop.route.moor_fallen_log',
    'generatorId': 'route.fallen_log.v1',
    'template': 'moor_fallen_log',
    'seed': 112,
    'paletteId': 'moor_grey',
    'detail': 'standard',
    'params': {
      'width': 120,
      'height': 38,
      'profile': 'low',
      'mossCover': 0.64,
      'saltWear': 0.08
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.moor_dead_bracken.v1',
    'assetId': 'prop.route.moor_dead_bracken',
    'generatorId': 'route.dead_bracken.v1',
    'template': 'moor_dead_bracken',
    'seed': 861,
    'paletteId': 'moor_grey',
    'detail': 'standard',
    'params': {
      'width': 76,
      'height': 98,
      'lean': 0.04,
      'fronds': 7,
      'brokenTips': 2
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.moor_wind_bracken.v1',
    'assetId': 'prop.route.moor_wind_bracken',
    'generatorId': 'route.dead_bracken.v1',
    'template': 'moor_wind_bracken',
    'seed': 862,
    'paletteId': 'moor_grey',
    'detail': 'standard',
    'params': {
      'width': 68,
      'height': 88,
      'lean': 0.18,
      'fronds': 6,
      'brokenTips': 1
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.moor_sparse_bracken.v1',
    'assetId': 'prop.route.moor_sparse_bracken',
    'generatorId': 'route.dead_bracken.v1',
    'template': 'moor_sparse_bracken',
    'seed': 863,
    'paletteId': 'coastal_salt',
    'detail': 'standard',
    'params': {
      'width': 80,
      'height': 92,
      'lean': -0.1,
      'fronds': 5,
      'brokenTips': 3
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.causeway_tide_pool.v1',
    'assetId': 'prop.route.causeway_tide_pool',
    'generatorId': 'route.tide_pool.v1',
    'template': 'causeway_tide_pool',
    'seed': 1440,
    'paletteId': 'coastal_salt',
    'detail': 'standard',
    'params': {
      'width': 620,
      'height': 78,
      'edge': 'broken-stone',
      'ripples': 5,
      'depth': 0.65
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.causeway_silt_pool.v1',
    'assetId': 'prop.route.causeway_silt_pool',
    'generatorId': 'route.tide_pool.v1',
    'template': 'causeway_silt_pool',
    'seed': 1441,
    'paletteId': 'moor_grey',
    'detail': 'standard',
    'params': {
      'width': 520,
      'height': 70,
      'edge': 'silt',
      'ripples': 4,
      'depth': 0.45
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.causeway_shingle_pool.v1',
    'assetId': 'prop.route.causeway_shingle_pool',
    'generatorId': 'route.tide_pool.v1',
    'template': 'causeway_shingle_pool',
    'seed': 1442,
    'paletteId': 'coastal_salt',
    'detail': 'standard',
    'params': {
      'width': 460,
      'height': 70,
      'edge': 'shingle',
      'ripples': 3,
      'depth': 0.32
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.moor_mist_shelf.v1',
    'assetId': 'prop.route.moor_mist_shelf',
    'generatorId': 'route.mist_shelf.v1',
    'template': 'moor_mist_shelf',
    'seed': 4700,
    'paletteId': 'moor_grey',
    'detail': 'standard',
    'params': {
      'width': 300,
      'height': 96,
      'shelf': 'continuous',
      'banks': 3,
      'density': 0.58
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.moor_split_mist_shelf.v1',
    'assetId': 'prop.route.moor_split_mist_shelf',
    'generatorId': 'route.mist_shelf.v1',
    'template': 'moor_split_mist_shelf',
    'seed': 12000,
    'paletteId': 'coastal_salt',
    'detail': 'standard',
    'params': {
      'width': 320,
      'height': 98,
      'shelf': 'broken',
      'banks': 4,
      'density': 0.48
    }
  },
  {
    'schema': 'helix.route-prop-recipe.v1',
    'id': 'route.moor_low_mist_shelf.v1',
    'assetId': 'prop.route.moor_low_mist_shelf',
    'generatorId': 'route.mist_shelf.v1',
    'template': 'moor_low_mist_shelf',
    'seed': 4701,
    'paletteId': 'moor_grey',
    'detail': 'standard',
    'params': {
      'width': 260,
      'height': 80,
      'shelf': 'continuous',
      'banks': 2,
      'density': 0.35
    }
  }
] as const satisfies readonly Recipe[];
